import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NetworkEcosystemRoutingModule } from './network-ecosystem-routing.module';
import { NetworkEcoPageComponent } from './components/network-eco-page/network-eco-page.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { AdminNetworkEcoComponent } from './components/admin-network-eco/admin-network-eco.component';


@NgModule({
  declarations: [NetworkEcoPageComponent, AdminNetworkEcoComponent],
  imports: [
    CommonModule,
    NetworkEcosystemRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class NetworkEcosystemModule { }
